import { CodeScope } from 'civil-status/constants/code-scope';
import { DateTime } from 'luxon';
import { BaseTableRows } from 'shell/components/shared/table/types';
import { Order } from 'shell/view-models/order';

export const initialValues: ArchiveAnnotationsForm = {
  isSelectedAll: false,
  itemsSelected: [],
  startDate: null,
  endDate: null,
  startDateRegistration: null,
  endDateRegistration: null,
  typeEvent: '',
  year: '',
  portion: '',
  serie: '',
  volume: '',
  number: '',
  codiceAmbito: CodeScope.ARCHIVIO,
  owners: '',
  state: '',
};

export interface ArchiveAnnotationsForm {
  isSelectedAll?: boolean;
  itemsSelected?: Array<number>;
  state?: string;
  startDate?: DateTime | null;
  endDate?: DateTime | null;
  startDateRegistration?: DateTime | null;
  endDateRegistration?: DateTime | null;
  practice?: string;
  typeEvent?: string;
  owners?: string;
  year?: string;
  portion?: string;
  serie?: string;
  volume?: string;
  number?: string;
  page?: number;
  rowsPerPage?: number;
  orders?: Order;
  codiceAmbito?: string;
}

export interface ArchiveAnnotationsListVM extends BaseTableRows {
  id: number;
  practice?: string;
  description?: string;
  dateFormation?: string;
  act?: string;
  state?: string | JSX.Element;
  codeState?: string;
  rejectReason?: string;
  dateRegistration?: string;
  action?: JSX.Element;
  itemArchivioAnnotazioni: ArchivioAnnotazioni;
}

export interface ArchivioAnnotazioni {
  key: { idDatiComunicazione: number };
  tipoAttoSecondario?: string;
  testoNote?: string;
  testoIntestazione?: string;
  codComunicazione?: string;
  codCondizione?: string;
  codStatoComunicazione?: string;
  codParteAttoPrimario?: string;
  codRegistroAttoPrimario?: string;
  codSerieAttoPrimario?: string;
  codVolumeAttoPrimario?: string;
  nrAnnoAttoPrimario?: number;
  nrAttoPrimario?: number;
  timestampInserimento?: string;
  timestampUltimoAggiornamento?: string;
  dataRegistrazioneAnnotazione?: string;
  idAnscAttoSecondario?: string;
  nomeReport?: string;
  testoMotivoAnnulloRifiuto?: string;
}
